import signalr from '@/f1/service/signalr';
import uuid from 'uuid/v1';

let vaild  = ["setting", "pattern", "refresh", "path", "check", "list", "backup", "restore", "download", "download_raw", "remove", "remove_raw", "pong", "status", "result", "error"]
let resolveMapWS = {};

const ws = {
  Cmd(cmd = undefined, agent_id="", body) {
    return new Promise((resolve, reject) => {
      try {
        let UUID = "";
        if(agent_id == "undefined") { resolve("") }
        else if(cmd.indexOf("_") > -1) { UUID  = `${ws.user_id}.${cmd.split("_")[0]}` }
        else if(cmd === "ping") { UUID  = `${ws.user_id}.pong` }
        else if(cmd === "start") { UUID  = `result` }
        else { UUID  = `${ws.user_id}.${cmd}` }
        resolveMapWS[UUID] = { resolve, reject };
        // console.log('signalr.socket()', signalr.socket())
        // location.hostname == "localhost" ? console.log("webcastle ws", "cmd", `${cmd}`, agent_id) : '';
        return signalr.invoke('webcastle', { app_id: 'webcastle', cmd : `${cmd}.${agent_id}`,  body : body });
      } catch (e) { console.log(e); reject(e); }
    });
  },
  user_id : "ws."+uuid()
}


signalr.subscribe('webcastle', (response) => {
  try {
    if(!response || !response.cmd) { return; }
    try { if(response.cmd != "pong") { response.body = typeof response.body == "string" ? JSON.parse(response.body) : response.body; } }
    catch(e) { console.log("parser error or from data mq version"); return; }
    if(!response || response.body == null) { console.log("result null or error"); return; }
    let cmd = response.cmd === "result" ? "result" : `${ws.user_id}.${response.cmd}` || '';
    if(vaild.indexOf(response.cmd) === -1) { console.log("check cmd", cmd); return; }

    if(resolveMapWS[cmd]) {
      response.ch = "ws";
      // location.hostname == "localhost" ? console.log("webcastle ws", "cmd", `${response.cmd}`, response) : '';
      resolveMapWS[cmd].resolve(response);
      delete resolveMapWS[cmd];
    }
  } catch (e) { console.log(e) }
});
export default ws;
